goog.provide('el8.print.schedule');

goog.require('el8.template.print.schedule');
goog.require('el8.practicedata.appts');
goog.require('el8.practicedata.recurringEventSchedules');
goog.require('el8.apphome.scheduler.renderer');
goog.require('el8.apphome.scheduler.util');
goog.require('el8.service.tz');
goog.require('el8.util.print');
goog.require('el8.util.consts');
goog.require('el8.data.init');
goog.require('el8.appservice.status');
goog.require('el8.data.practices');


el8.print.schedule.init = function(spec) {

    el8.appservice.status.init();
    if (spec.data) { el8.data.init(spec.data); }

    var practice = el8.data.practices.create(spec.practice);
    var requestedDate = el8.service.tz.toTzDate(spec.requestedDate);
    var appts = el8.practicedata.appts.create(spec.appts);
    var recurrings = el8.practicedata.recurringEventSchedules.create(spec.recurrings);

    var virtualEvents = [];
    for (var i=0; i<recurrings.length; i++) {
        var recurring = recurrings[i];
        // only generate virtual events for Other Events
        if (recurring.getTimeSlotType() === 2) {
          var newEvent = recurring.scheduleVirtualEvent(requestedDate);
          if (newEvent) { virtualEvents.push(newEvent); }
        }
    }
    var allEvents = [];
    appts.forEach(function (appt) {
      if (!appt.isOpenSlot()) { allEvents.push(appt); }
    });
    allEvents.addArray(virtualEvents);
    allEvents.sort(function(a, b) {
        var diffStart = a.getApptTime().getTime() - b.getApptTime().getTime();
        if (diffStart !== 0) { return diffStart; }
        return a.getEndApptTime().getTime() - b.getEndApptTime().getTime();
    });

    // Only want to show from min(earliest appt, 8am) to max(latest appt, 5pm)
    var minTime = el8.service.tz.newTzTime(8);
    var maxTime = el8.service.tz.newTzTime(17);
    if (allEvents.length > 0) {
        minTime = (allEvents[0].getStartTime().getTime() < minTime) ?
            el8.apphome.scheduler.util.getClosestIntervalTime(allEvents[0].getStartTime(), el8.data.practiceSettings.getScheduleInterval()) :
            minTime;
        maxTime = (allEvents[allEvents.length-1].getStartTime().getTime() > maxTime) ?
            el8.apphome.scheduler.util.getClosestIntervalTime(allEvents[allEvents.length-1].getEndTime(), el8.data.practiceSettings.getScheduleInterval()) :
            maxTime;

        // this scenario happens when the last appt ends on a different day than the
        // requested day (e.g. the next day at midnight). We don't want the maxTime to
        // look something like it's before or just after the min time, so we'll force
        // max time to be the last timeslot of the requested day.
        var maxEndDay = allEvents[allEvents.length-1].getEndApptTime().date;
        if (maxEndDay !== requestedDate.date) {
            maxTime = el8.apphome.scheduler.util.getClosestIntervalTime(el8.service.tz.newTzTime(23, 59), el8.data.practiceSettings.getScheduleInterval());
        }
    }
    var slots = el8.apphome.scheduler.renderer.day(
        requestedDate, allEvents, el8.data.practiceSettings.getScheduleInterval(), {
            minTime: minTime,
            maxTime: maxTime
        }
    );

    $('.print-content').replaceWith(
        el8.template.print.schedule.content({
            requestedDate: el8.service.tz.soyStr(requestedDate),
            physicianName: spec.physicianName,
            practice: practice.asSoyMap(),
            slots: slots
        })
    );

    el8.util.print.pageSetup();

};
